import { FC } from "react";

import { ExtendedViewItem } from "@/types/receipt";
import { getSharingWarningText } from "@/utils/extendedViewHelpers";

import styles from "./SharingWarning.module.css";

interface SharingWarningProps {
  item: Pick<
    ExtendedViewItem,
    "share_url_email" | "share_url_phone_number" | "extended_view_position"
  >;
  email?: string | null;
  phoneNumber?: string | null;
  lang: string;
}

export const SharingWarning: FC<SharingWarningProps> = ({
  item,
  email,
  phoneNumber,
  lang,
}) => {
  const showEmail = item.share_url_email && email;
  const showPhone = item.share_url_phone_number && phoneNumber;

  if (!showEmail && !showPhone) return null;

  return (
    <div className={styles.warningBox}>
      {showEmail && (
        <div>
          {getSharingWarningText(item.extended_view_position, "email", lang)}
        </div>
      )}
      {showPhone && (
        <div className={showEmail ? styles.warningPhone : undefined}>
          {getSharingWarningText(item.extended_view_position, "phone", lang)}
        </div>
      )}
    </div>
  );
};
